export const lineInfo = `
  query {
    lineInfo {
      displayBtn
      sanitizeInformationContext
    }
  }
`;
